/**
 * Actions
 */
export class FinishAction {}

export class GoBackAction {}

export class GoBackRouteAction {}

export class PartialUpdateAction {}

export const finish = (): FinishAction => {
  return new FinishAction();
};

export const partiallyUpdate = (): PartialUpdateAction => {
  return new PartialUpdateAction();
};

/**
 * ValidationAction
 */
export class ValidationAction {
  msg: string;

  $els?: string[];

  constructor(msg: string, $els?: string[]) {
    this.msg = msg;
    this.$els = $els;
  }
}

export const invalid = (msg: string, $els: string[]): ValidationAction => {
  return new ValidationAction(msg, $els);
};

export const required = (...args) => invalid('Required', [...args]);
/**
 * RouteAction
 */
export class RouteAction {
  nextPath: string;
  queryString: (state: any) => any;

  constructor(nextPath: string) {
    this.nextPath = nextPath;
  }
}

export const routeTo = (nextPath: string): RouteAction => {
  return new RouteAction(nextPath);
};
export const routeBack = (): GoBackAction => {
  return new GoBackAction();
};

/**
 * RJPutOnPathAction
 */
export class RJPutOnPathAction {}

export const putOnPath = (): RJPutOnPathAction => {
  return new RJPutOnPathAction();
};

/**
 * ModalAction
 */
export class ModalAction {
  contents: any;

  constructor(modalContents: any) {
    this.contents = modalContents;
  }
}

export const openModal = (modalContents: any): ModalAction => {
  return new ModalAction(modalContents);
};
export type NavAction =
  | RouteAction
  | FinishAction
  | GoBackAction
  | GoBackRouteAction
  | ModalAction
  | RJPutOnPathAction;

export type Action = ValidationAction | NavAction | PartialUpdateAction;
